<div class="pdfback" (click)="dismiss()"></div>
<div class="pdfdlg" role="dialog" appDialogFocus [attr.aria-label]="S['Export to PDF']" [attr.aria-busy]="busy" (keydown.escape)="dismiss()">
  <header class="pdfdlg__head">
    <h2 class="pdfdlg__title">{{ S['Export to PDF'] }}</h2>
    <button class="iconbtn iconbtn--bare" [title]="S['Close']" (click)="dismiss()" [disabled]="busy" [attr.aria-label]="S['Close']">
      <app-icon name="close" size="16" />
    </button>
  </header>

  <!-- The prototype's two-column grid: Export, (Sheet), Orientation, Paper size. -->
  <div class="pdfdlg__grid">
    <label class="pdfdlg__field">
      <span class="pdfdlg__label">{{ S['Export'] }}</span>
      <select class="pdfdlg__select" (change)="scope.set($any($event.target).value)" [disabled]="busy" [attr.aria-label]="S['Export']">
        <option value="workbook" [selected]="scope() === 'workbook'">{{ S['Entire workbook'] }}</option>
        <option value="sheet" [selected]="scope() === 'sheet'">{{ S['One sheet'] }}</option>
      </select>
    </label>
    @if (scope() === 'sheet') {
      <label class="pdfdlg__field">
        <span class="pdfdlg__label">{{ S['Sheet'] }}</span>
        <select class="pdfdlg__select" (change)="sheetId.set($any($event.target).value)" [disabled]="busy" [attr.aria-label]="S['Sheet']">
          @for (sheet of sheetList(); track sheet.id) {
            <option [value]="sheet.id" [selected]="sheet.id === chosenSheet()">{{ sheet.name }}</option>
          }
        </select>
      </label>
    }
    <label class="pdfdlg__field">
      <span class="pdfdlg__label">{{ S['Orientation'] }}</span>
      <select class="pdfdlg__select" (change)="orientation.set($any($event.target).value)" [disabled]="busy" [attr.aria-label]="S['Orientation']">
        <option value="landscape">{{ S['Landscape'] }}</option>
        <option value="portrait">{{ S['Portrait'] }}</option>
      </select>
    </label>
    <label class="pdfdlg__field">
      <span class="pdfdlg__label">{{ S['Paper size'] }}</span>
      <select class="pdfdlg__select" (change)="paper.set($any($event.target).value)" [disabled]="busy" [attr.aria-label]="S['Paper size']">
        <option value="a4">{{ S['A4'] }}</option>
        <option value="letter">{{ S['US Letter'] }}</option>
      </select>
    </label>
  </div>

  <p class="pdfdlg__note">
    {{ S['Visible cells and calculated values, formatted as a paginated grid. Wide sheets continue on extra pages. Hidden rows and columns are omitted; whole-workbook export also omits hidden sheets.'] }}
  </p>

  <!-- Row 68: Cancel and "Download PDF" are disabled while the PDF is made, which the primary says; the
       primary also until the engine is ready. The dialog closes when the file is made. -->
  <footer class="pdfdlg__foot">
    <button class="btn btn--ghost" (click)="dismiss()" [disabled]="busy" [attr.aria-label]="S['Cancel']">{{ S['Cancel'] }}</button>
    <button class="btn btn--primary" (click)="emit()" [disabled]="busy || !ready" [attr.aria-label]="busy ? S['Preparing download…'] : S['Download PDF']">
      <app-icon name="download" size="16" />
      {{ busy ? S['Preparing download…'] : S['Download PDF'] }}
    </button>
  </footer>
</div>
